import { formatElapsed } from '@/application/timer/timerStore';
import { strings } from '@/shared/strings';
import { ConfirmSheet } from '@/ui/primitives/ConfirmSheet';

/**
 * Pause, asked first. Request of 5 October 2026: a stray tap on Pause stopped a
 * clock without a word. The statement says the time it stops at, which is the
 * time the clock keeps.
 */
export function PauseConfirm({
  jobOrderNo,
  elapsedSeconds,
  busy,
  onConfirm,
  onCancel,
}: {
  jobOrderNo: string;
  elapsedSeconds: number;
  busy: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  return (
    <ConfirmSheet
      title={strings.pause.title}
      statement={strings.pause.statement(jobOrderNo, formatElapsed(elapsedSeconds))}
      confirmLabel={strings.pause.confirm}
      cancelLabel={strings.pause.cancel}
      closeLabel={strings.sheet.close}
      busy={busy}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}
